module.exports = __webpack_public_path__ + "static/media/becomeClient.82aeb4a1.svg";